import * as angular from "angular";

export class EmailService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/contact/email";
    }

    send(email: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/send", email);
    }
}

angular.module("vcServices").service("EmailService", EmailService);
